import React from 'react'
import { useListDirectoryScanSettings } from 'src/pages/Evidence/evidence.hooks'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'
import { LoadingFilterDropdown } from './FilterDropdown.components'

export const FolderScanFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { data: directoryScanSettings, isLoading } =
      useListDirectoryScanSettings()

    if (!directoryScanSettings || isLoading) {
      return (
        <LoadingFilterDropdown
          filterName={FilterName.FOLDER_SCAN}
          isNested={isNested}
        />
      )
    }

    const filterValues = directoryScanSettings
      .getSettingsList()
      .map((setting) => ({
        value: setting.getId(),
        label: setting.getName() || setting.getRootPath(),
      }))

    return (
      <FilterDropdown
        filterParam={FilterParam.FOLDER_SCAN}
        filterName={FilterName.FOLDER_SCAN}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
